import { Img } from '@/components/blocks/MaterialImage';
import { Skeleton } from '@mui/material';

export const AccountInterestSkeleton = () => (
	<Skeleton
		variant="rectangular"
		sx={{
			width: '100%',
			height: '182px',
		}}
	/>
);
